import { graphql } from '@/graphql-setup'
import { TagFragment } from './queries'

export const CREATE_TAG_MUTATION = graphql(
  `
    mutation CreateTag($input: CreateTagInput!) {
      createTag(input: $input) {
        tag {
          ...TagInfo
        }
      }
    }
  `,
  [TagFragment]
)

export const PATCH_TAG_MUTATION = graphql(
  `
    mutation PatchTag($id: ID!, $input: PatchTagInput!) {
      patchTag(id: $id, input: $input) {
        tag {
          ...TagInfo
        }
      }
    }
  `,
  [TagFragment]
)

export const DELETE_TAG_MUTATION = graphql(`
  mutation DeleteTag($id: ID!) {
    deleteTag(id: $id) {
      found
      deletedId
    }
  }
`)
